import { c as _c } from "react/compiler-runtime";
import NextImage from 'next/image';
interface PropTypes {
  text: string;
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  disabled?: boolean;
}
function GoogleOAuthButton(t0) {
  const $ = _c(9);
  const {
    text,
    onClick,
    className,
    disabled
  } = t0;
  const t1 = `flex h-12 w-full flex-row items-center justify-center rounded-md border border-white/10 bg-white px-4 text-black transition hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-white/40 focus:ring-offset-2 focus:ring-offset-black disabled:cursor-not-allowed disabled:opacity-60 ${className || ""}`;
  const t2 = disabled || undefined;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mr-3 flex h-full items-center justify-center"><NextImage src="/assets/app/google-logo.png" alt="" width={20} height={20} /></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== text) {
    t4 = <span className="font-bold">{text}</span>;
    $[1] = text;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== disabled || $[4] !== onClick || $[5] !== t1 || $[6] !== t2 || $[7] !== t4) {
    t5 = <button type="button" className={t1} onClick={onClick} disabled={disabled} aria-busy={t2}>{t3}{t4}</button>;
    $[3] = disabled;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
export default GoogleOAuthButton;